/**
 * 계약기간을 개월 수로 환산한다. v1 `lib/siteContractMonths.ts` 를 옮긴 것으로 규칙은 그대로다.
 *
 * 종료일을 포함해서 센다 — 4/1~4/30 은 0개월이 아니라 1개월이다.
 */
export function diffCalendarMonthsInclusive(start: string | null, end: string | null): number | null {
  if (!start || !end) return null;

  const startDate = new Date(start);
  const endDate = new Date(end);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return null;
  if (endDate.getTime() < startDate.getTime()) return null;

  // 종료일 다음 날까지를 구간으로 보면 "포함해서 세기"가 뺄셈 한 번으로 끝난다.
  const inclusiveEnd = new Date(endDate);
  inclusiveEnd.setDate(inclusiveEnd.getDate() + 1);

  let months =
    (inclusiveEnd.getFullYear() - startDate.getFullYear()) * 12 +
    (inclusiveEnd.getMonth() - startDate.getMonth());

  if (inclusiveEnd.getDate() < startDate.getDate()) months -= 1;

  return months >= 0 ? months : null;
}

/** 예: `18개월`. 계산할 수 없으면 빈 문자열. */
export function formatContractMonthsLabel(start: string | null, end: string | null): string {
  const months = diffCalendarMonthsInclusive(start, end);
  return months === null ? '' : `${months}개월`;
}
